<template>
  <div class="collage-carousel" ref="rootRef">
    <div class="collage-grid">
      <div class="collage-item">
        <!-- Contenedor enmarcado con cambio de imagen fluido -->
        <div class="marco-foto-wrapper" @click="enlargeImage">
          <transition name="fade-suave" mode="out-in">
            <img
              :key="currentIndex"
              :src="images[currentIndex]"
              class="collage-image"
              :alt="'Imagen ' + currentIndex"
            >
          </transition>
          <img
            src="@/assets/marco2.png"
            class="marco-overlay"
            alt="Marco decorativo"
            aria-hidden="true"
          >
        </div>
      </div>
    </div>
 
    <!-- Modal -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <div class="modal-content-wrapper">
        <img
          :src="images[currentIndex]"
          class="enlarged-image"
        >
      </div>
    </div>
  </div>
</template>
 
<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'
 
export default {
  name: 'CollageAnimado',
  setup() {
    // 📸 AQUÍ PUEDES AGREGAR TODAS LAS FOTOS QUE QUIERAS QUE CAMBIEN CADA SEGUNDO
    const images = [
       require('@/assets/c956b85ea7c71fd1588a6f6a858a56e1.png'),
    ]
 
    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    const rootRef = ref(null)
    let intervalId = null
 
    const enlargeImage = () => {
      isImageEnlarged.value = true
    }
 
    const closeModal = () => {
      isImageEnlarged.value = false
    }

    // Rotación automática cada 1 segundo
    const iniciarCarrusel = () => {
      if (images.length > 1 && !intervalId) {
        intervalId = setInterval(() => {
          currentIndex.value = (currentIndex.value + 1) % images.length
        }, 1000)
      }
    }
 
    onMounted(async () => {
      await nextTick()
 
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Animación GSAP al entrar en el viewpoint (primer mundo, fina y delicada)
            gsap.fromTo(
              rootRef.value,
              { opacity: 0, y: 50, scale: 0.94, filter: 'blur(10px)' },
              { 
                autoAlpha: 1, 
                y: 0, 
                scale: 1, 
                filter: 'blur(0px)', 
                duration: 1.5, 
                ease: 'power3.out',
                onComplete: () => {
                  iniciarCarrusel()
                }
              }
            )
            observer.disconnect()
          }
        })
      }, { threshold: 0.3 })
 
      if (rootRef.value) {
        observer.observe(rootRef.value)
      }
    })

    onUnmounted(() => {
      if (intervalId) clearInterval(intervalId)
    })
 
    return {
      images,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal,
      rootRef,
    }
  }
}
</script>
 
<style scoped>
.collage-carousel {
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  opacity: 0; /* Oculto inicialmente para GSAP */
  will-change: transform, opacity, filter;
}
 
.collage-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 0;
  width: 100%;
  max-width: 420px;
}
 
.collage-item {
  grid-column: span 12;
  cursor: pointer;
}

/* CONTENEDOR DEL MARCO Y LA FOTO */
.marco-foto-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 5;
  padding: 12% 11% 25% 12%; /* Área interior exacta del marco PNG */
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
 
.collage-image {
  position: absolute;
  width: calc(100% - 23%);
  height: calc(100% - 37%);
  object-fit: cover; 
  border-radius: 2px;
  display: block;
  z-index: 1;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.marco-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill; 
  pointer-events: none;
  z-index: 2;
  filter: drop-shadow(0 8px 24px rgba(0,0,0,0.15));
}

/* TRANSICIÓN SUAVE Y FLUIDA ENTRE IMÁGENES */
.fade-suave-enter-active,
.fade-suave-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-suave-enter-from {
  opacity: 0;
  transform: scale(1.02);
}

.fade-suave-leave-to {
  opacity: 0;
  transform: scale(0.98);
}
 
/* Modal Premium */
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(10, 10, 10, 0.88);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  animation: fadeInModal 0.3s ease forwards;
}

.modal-content-wrapper {
  position: relative;
  max-width: 95%;
  max-height: 95%;
  display: flex;
  align-items: center;
  justify-content: center;
}
 
.enlarged-image {
  max-width: 80vw;
  max-height: 80vh;
  border-radius: 8px;
  object-fit: contain;
  box-shadow: 0 20px 50px rgba(0,0,0,0.5);
  animation: scaleUpModal 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes fadeInModal {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleUpModal {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
</style>